interface MessageToolProps {
  toolName: string;
  args: any;
  result?: string;
  status?: "running" | "complete" | "error";
}

export function MessageTool({
  toolName: _toolName,
  args,
  result,
  status,
}: MessageToolProps) {
  // Parse the result if available
  let parsedResult: any = null;
  if (result) {
    try {
      parsedResult = JSON.parse(result);
    } catch (e) {
      console.warn("Failed to parse message result:", result);
    }
  }

  return (
    <div>
      {/* Show parameters as simple text */}
      {args && Object.keys(args).length > 0 && (
        <div className="space-y-1 text-sm text-gray-500">
          {Object.entries(args).map(([key, value]) => (
            <div key={key}>
              {key.replace(/_/g, " ")}: {String(value)}
            </div>
          ))}
        </div>
      )}

      {/* Show structured results when complete */}
      {parsedResult && status === "complete" && (
        <div className="mt-3">
          <div className="rounded-lg bg-gray-50 p-3">
            <div className="mb-1 font-medium text-gray-900">
              {_toolName.includes("conversation")
                ? "Conversation Summary"
                : _toolName.includes("note")
                  ? "Notes"
                  : _toolName.includes("escalation")
                    ? "Escalations"
                    : "Messages"}
            </div>
            <div className="text-sm text-gray-600">
              {Array.isArray(parsedResult)
                ? `Found ${parsedResult.length} items`
                : "Data processed successfully"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
